import Flickity from 'flickity';
import 'flickity-fullscreen';
import 'flickity-fade';
import imagesLoaded from 'imagesloaded';

export function secondaryFlickity(element, alignment = 'center') {
  if (!element) return;

  let flkty;
  const cellAlign = alignment;

  element.classList.remove('flickity-enabled', 'is-draggable');

  imagesLoaded(element, () => init());


  let resizeTimeout;
  function resizeHandler() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      if (flkty) flkty.resize();
    }, 150);
  }
  window.addEventListener('resize', resizeHandler);

  function init() {
    if (flkty) flkty.destroy();

    flkty = new Flickity(element, {
      cellAlign,
      contain: true,
      pageDots: true, // disable Flickity’s default dots
      prevNextButtons: true,
      wrapAround: true,
      groupCells: false,
      freeScroll: false,
      draggable: true,
      adaptiveHeight: true,
    });

    flkty.on('ready', () => {
      flkty.resize();
      setupCustomNav();
    });

    setTimeout(() => flkty.resize(), 100);
  }

  return {
    instance: () => flkty,
    destroy: () => {
      if (flkty) flkty.destroy();
      window.removeEventListener('resize', resizeHandler);
    },
  };
}
